import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import { App as AntApp } from 'antd';
import AppRouter from "./Router";
import { GOOGLE_CLIENT_ID } from "./config/env";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  if (!GOOGLE_CLIENT_ID) {
    return (
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
        </QueryClientProvider>
      </AntApp>
    );
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
        </QueryClientProvider>
      </AntApp>
    </GoogleOAuthProvider>
  );
}

export default App;
